export const UNCATEGORIZED_DOMAIN_KEY = "__uncategorized__";
export const UNCATEGORIZED_DOMAIN_LABEL = "Uncategorized";

export function getOrganizationDomainKey(org) {
  const rawDomain = String(org?.domain_hint || org?.domainHint || "").trim();
  return rawDomain ? rawDomain.toLowerCase() : UNCATEGORIZED_DOMAIN_KEY;
}

export function formatOrganizationDomainLabel(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue || rawValue === UNCATEGORIZED_DOMAIN_KEY) {
    return UNCATEGORIZED_DOMAIN_LABEL;
  }
  return rawValue
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function getOrganizationDomainLabel(org) {
  return formatOrganizationDomainLabel(getOrganizationDomainKey(org));
}

export function buildOrganizationDomainGroups(organizations = []) {
  const groupsByKey = new Map();

  organizations.forEach((org) => {
    const key = getOrganizationDomainKey(org);
    const label = getOrganizationDomainLabel(org);
    if (!groupsByKey.has(key)) {
      groupsByKey.set(key, {
        key,
        label,
        organizations: [],
      });
    }
    groupsByKey.get(key).organizations.push(org);
  });

  return Array.from(groupsByKey.values())
    .map((group) => ({
      ...group,
      organizations: [...group.organizations].sort((a, b) =>
        String(a.name || a.org_name || "").localeCompare(String(b.name || b.org_name || "")),
      ),
    }))
    .sort((a, b) => {
      if (a.key === UNCATEGORIZED_DOMAIN_KEY) return 1;
      if (b.key === UNCATEGORIZED_DOMAIN_KEY) return -1;
      return a.label.localeCompare(b.label);
    });
}

export function findOrganizationDomainKey(organizations = [], orgId = "") {
  const selected = organizations.find((org) => String(org.org_id) === String(orgId));
  return selected ? getOrganizationDomainKey(selected) : "";
}

export function organizationMatchesSearch(org, searchText = "") {
  const query = String(searchText || "").trim().toLowerCase();
  if (!query) {
    return true;
  }
  return [
    org?.name,
    org?.org_name,
    org?.org_id,
    org?.domain_hint,
    getOrganizationDomainLabel(org),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .includes(query);
}
